import { getProfileIconColor, getProfileIconImage } from '../../utils/common/profileIcon';

import type { Staff } from '../staff/types';
import type { Student } from '../students/types';

export type CurrentUserData = Staff | Student;

// Accessors for fields the compiler can't index directly on the
// Staff | Student union: the staff route schema omits email/phoneNumber
// (though self-views include them at runtime), and profileIcon's union has
// color-only and image-only members
export const getCurrentUserEmail = (user?: CurrentUserData): string | undefined =>
  user && 'email' in user ? user.email : undefined;

export const getCurrentUserPhoneNumber = (user?: CurrentUserData): string | undefined =>
  user && 'phoneNumber' in user ? user.phoneNumber : undefined;

export const getCurrentUserSlackUserId = (user?: CurrentUserData): string | undefined =>
  user?.slackUserId;

export const getProfileIconParts = (
  profileIcon?: CurrentUserData['profileIcon']
): { color?: string; image?: string } => ({
  color: getProfileIconColor(profileIcon),
  image: getProfileIconImage(profileIcon),
});
